import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import ReturnArrowIcon from 'dibs-vg/dist/react/return-arrow';
import { PdpSharedReturnModalLoader } from '../PdpSharedModals/PdpSharedReturnModal/PdpSharedReturnModalLoader';
import { PdpSharedBlurb } from './PdpSharedBlurb/PdpSharedBlurb';
import { returnsTitle, returnsText, returnsCta } from '../messages/pdpBlurbMessages';

// styles
import styles from './PdpSharedBlurbs.scss';

// helpers
import tracking from 'dibs-tracking';

export class PdpSharedBlurbReturnsComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = { isModalOpen: false };
        this.openReturnsModal = this.openReturnsModal.bind(this);
        this.closeReturnsModal = this.closeReturnsModal.bind(this);
    }

    openReturnsModal() {
        this.setState(() => ({ isModalOpen: true }));
        tracking.trackEvent({
            category: 'product',
            action: 'view return details',
            label: 'pdp sidebar|returns accepted',
        });
    }

    closeReturnsModal() {
        this.setState(() => ({ isModalOpen: false }));
    }

    render() {
        const { relay, item, itemId, user, userId } = this.props;
        const { isModalOpen } = this.state;
        const userIsVerifiedTrade = user && user.isVerifiedTrade;
        const returnPolicy = item && item.blurbReturnPolicy;
        const itemHasReturnPolicy = !!returnPolicy;

        if (userIsVerifiedTrade || !itemHasReturnPolicy || !returnPolicy.accept) {
            return null;
        }

        const returnPolicyLength = returnPolicy.notifyDays;
        return (
            <PdpSharedBlurb IconComponent={ReturnArrowIcon} dataTn="pdp-blurb-returns">
                <span className={styles.title}>{returnsTitle}: </span>
                {returnsText(returnPolicyLength)}{' '}
                <a href="#return-policy-modal" onClick={this.openReturnsModal}>
                    {returnsCta}
                </a>
                <PdpSharedReturnModalLoader
                    itemId={itemId}
                    userId={userId}
                    environment={relay.environment}
                    isOpen={isModalOpen}
                    onClose={this.closeReturnsModal}
                />
            </PdpSharedBlurb>
        );
    }
}

PdpSharedBlurbReturnsComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    itemId: PropTypes.string,
    user: PropTypes.object,
    userId: PropTypes.string,
};

export const PdpSharedBlurbReturns = createFragmentContainer(PdpSharedBlurbReturnsComponent, {
    user: graphql`
        fragment PdpSharedBlurbReturns_user on User {
            isVerifiedTrade
        }
    `,
    item: graphql`
        fragment PdpSharedBlurbReturns_item on Item {
            blurbReturnPolicy: returnPolicy {
                accept
                notifyDays
            }
        }
    `,
});
